import React, { useEffect, useRef } from "react";
import { useEditor } from "../useEditor";
import { CkEditorHelper } from "./CkEditorHelper";

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

export function CKEditor(props: Props) {
	const editorContext = useEditor();
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (ref.current) {
			const observer = new MutationObserver(editorContext.onEditorDomChange);
			observer.observe(ref.current, { childList: true, subtree: true });
			return () => observer.disconnect();
		}
	}, [editorContext.onEditorDomChange]);

	const { id, ...divProps } = props;

	useEffect(
		() => {
			async function setupEditor(editorElement: Element) {
				const editor = await CkEditorHelper.createEditorInDOM(editorElement);
				editorContext.setEditor(editor);
			}

			const editorElement = document.querySelector("#editor");
			if (editorElement) {
				setupEditor(editorElement);
			} else {
				console.log("Editor id missing on initilization");
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	return <div id="editor" ref={ref} {...divProps} />;
}
